import { bank_switch as bankSwitch } from '#proto/index.qonto.account_management';

export const MovablePaymentStatus = bankSwitch.firstparty.v1.ApiStatus;
export type MovablePaymentStatus = (typeof MovablePaymentStatus)[keyof typeof MovablePaymentStatus];

export const MovablePaymentOperationType = bankSwitch.firstparty.v1.ApiOperationType;
export type MovablePaymentOperationType =
  (typeof MovablePaymentOperationType)[keyof typeof MovablePaymentOperationType];
